import { headlineStory } from "@/mocks/baoliaoData";

export default function HeroSection() {
  return (
    <section id="headline" className="relative w-full overflow-hidden">
      <div className="relative w-full h-[560px] md:h-[640px]">
        <img
          src={headlineStory.image}
          alt="星夜盲盒收官直播现场，舞台灯光绚烂，全场观众挥舞应援棒"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/55 to-foreground-950/10"></div>
        <div className="absolute inset-x-0 bottom-0">
          <div className="max-w-[1240px] mx-auto px-4 md:px-6 pb-10 md:pb-14 pt-24 md:pt-32">
            <div className="flex flex-col gap-4 md:gap-5 max-w-3xl animate-rise">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-3 py-1 text-xs font-semibold">
                  <i className="ri-flashlight-fill text-xs"></i>
                  {headlineStory.kicker}
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-background-50/15 text-background-50 border border-background-50/30 backdrop-blur px-3 py-1 text-xs">
                  {headlineStory.cat}
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-background-100/80">
                  <i className="ri-time-line"></i>
                  {headlineStory.time}
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-background-100/80">
                  <i className="ri-eye-line"></i>
                  {headlineStory.views} 阅读
                </span>
              </div>

              <h1 className="font-heading font-extrabold text-2xl md:text-4xl lg:text-[44px] leading-snug md:leading-[1.25] text-background-50 tracking-tight">
                {headlineStory.title}
              </h1>

              <p className="text-sm md:text-base text-background-100/85 leading-relaxed hidden sm:block max-w-2xl">
                {headlineStory.summary}
              </p>

              <div className="flex items-center gap-3 flex-wrap pt-1">
                <a
                  href="#track"
                  className="inline-flex items-center gap-2 rounded-full bg-primary-500 text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-primary-400 transition-colors whitespace-nowrap"
                >
                  <i className="ri-focus-3-line text-base"></i>
                  追踪最新进展
                </a>
                <a
                  href="#live"
                  className="inline-flex items-center gap-2 rounded-full bg-background-50/10 border border-background-50/30 backdrop-blur text-background-50 px-5 py-2.5 text-sm font-semibold hover:bg-background-50/25 transition-colors whitespace-nowrap"
                >
                  <i className="ri-arrow-down-line text-base"></i>
                  查看实时爆料
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}